import { icons } from "./icons";
import { IconProps } from "./types";

export const Icon: React.FC<IconProps> = ({ icon, ...rest }) => {
  const SvgIcon = icons[icon];
  return <SvgIcon {...rest} />;
};
